import {
  GameSettingType,
  SpeedometerType,
} from "@1games-ru/region-shared/dist/enums/account/settings";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export type BasicSettings = {
  [GameSettingType.SettingMainMenuTransparency]: number;
  [GameSettingType.SettingShowHotkeys]: boolean;
  [GameSettingType.SettingShowChat]: boolean;
  [GameSettingType.SettingShowMap]: boolean;
  [GameSettingType.SettingShowHUD]: boolean;
  [GameSettingType.SettingSpeedometerStyle]: SpeedometerType;
};

export interface BasicSettingsState {
  appliedSettings: BasicSettings | null;
  memoizedSettings: BasicSettings | null;
}

const initialState: BasicSettingsState = {
  appliedSettings: null,
  memoizedSettings: null,
};

const basicSettingsrSlice = createSlice({
  name: "basicSettings",
  initialState,
  reducers: {
    setAppliedSettings: (state, action: PayloadAction<Partial<BasicSettingsState>>) => {
      state.appliedSettings = { ...state.appliedSettings, ...action.payload };
    },
    setMemoizedSettings: (state, action: PayloadAction<Partial<BasicSettingsState> | null>) => {
      if (action.payload) {
        state.memoizedSettings = { ...state.memoizedSettings, ...action.payload };
      } else {
        state.memoizedSettings = null;
      }
    },
    reset: (state) => {
      state.appliedSettings = { ...state.memoizedSettings };
    },
  },
});

export const basicSettingsSelector = (state: RootState) => state.basicSettings;
export const appliedBasicSettingsSelector = (state: RootState) =>
  state.basicSettings.appliedSettings;
export const memoizedBasicSettingsSelector = (state: RootState) =>
  state.basicSettings.memoizedSettings;

export const basicSettingsReducer = basicSettingsrSlice.reducer;

export const { setAppliedSettings, setMemoizedSettings, reset } = basicSettingsrSlice.actions;
